import React from "react";

import {
  BORROWER_CONSTITUTION_LABELS,
  BorrowerConstitution,
} from "../../../api/enrichedStakeholder";

interface ConstitutionPillProps {
  value?: BorrowerConstitution | null;
}

const ConstitutionPill: React.FC<ConstitutionPillProps> = ({
  value,
}) => {
  const label =
    value !== null && value !== undefined
      ? BORROWER_CONSTITUTION_LABELS[value] ?? String(value)
      : "--";

  return (
    <span
      className="
        inline-flex
        shrink-0
        items-center
        justify-center
        rounded-[8px]
        border
        border-transparent
        bg-[#DCFCE7]
        px-2
        py-[2px]
        font-sans
        text-[12px]
        font-medium
        leading-4
        text-[#16A34A]
      "
    >
      {label}
    </span>
  );
};

export default ConstitutionPill;